import { render, staticRenderFns } from "./importXLS.vue?vue&type=template&id=1cd24b1d&scoped=true&"
import script from "./importXLS.vue?vue&type=script&lang=js&"
export * from "./importXLS.vue?vue&type=script&lang=js&"
import style0 from "./importXLS.vue?vue&type=style&index=0&id=1cd24b1d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd24b1d",
  null
  
)

export default component.exports